import { SEVERITY } from '../../utils/Snackbar';
import { hasJWT, getJWT, saveJWT, deleteJWT } from '../../utils/LocalStorage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const get = (path,success,error) => {
  Ajax(`${BACKEND_URL}/${path}`, 'GET', {}, success, error);
}

export const post = (path,json,success,error) => {
  Ajax(`${BACKEND_URL}/${path}`, 'POST', json, success, error);
}

export const put = (path,json,success,error) => {
  Ajax(`${BACKEND_URL}/${path}`, 'PUT', json, success, error);
}

export const del = (path,json,success,error) => {
  Ajax(`${BACKEND_URL}/${path}`, 'DELETE', json, success, error);
}

export const STATUSCODE = {
  HTTP_200_OK: 200,
  HTTP_201_CREATED: 201,
  HTTP_202_ACCEPTED: 202,
  HTTP_205_RESET_CONTENT: 205,

  HTTP_400_BAD_REQUEST: 400,
  HTTP_401_UNAUTHORIZED: 401,
  HTTP_402_PAYMENT_REQUIRED: 402,
  HTTP_404_NOT_FOUND: 404,
  HTTP_405_METHOD_NOT_ALLOWED: 405,
  HTTP_408_REQUEST_TIMEOUT: 408,
  HTTP_409_CONFLICT: 409,

  HTTP_500_INTERNAL_SERVER_ERROR: 500,
};

function getMessageByStatusCode(statusCode) {
  switch (statusCode) {
    case STATUSCODE.HTTP_200_OK: return {message: "Solicitação realizada com sucesso!", ok: true, severity: SEVERITY.INFO};
    case STATUSCODE.HTTP_201_CREATED: return {message: "Cadastro realizado com sucesso!", ok: true, severity: SEVERITY.SUCCESS};
    case STATUSCODE.HTTP_202_ACCEPTED: return {message: "Logout realizado com sucesso!", ok: true, severity: SEVERITY.INFO};
    case STATUSCODE.HTTP_205_RESET_CONTENT: return {message: "Logout realizado com sucesso!", ok: true, severity: SEVERITY.INFO};
    case STATUSCODE.HTTP_400_BAD_REQUEST: return {message: "Solicitação inválida!", ok: false, severity: SEVERITY.WARNING};
    case STATUSCODE.HTTP_401_UNAUTHORIZED: return {message: "Acesso não autorizado!", ok: false, severity: SEVERITY.WARNING};
    case STATUSCODE.HTTP_402_PAYMENT_REQUIRED: return {message: "Pagamento necessário!", ok: false, severity: SEVERITY.WARNING};
    case STATUSCODE.HTTP_404_NOT_FOUND: return {message: "Dados não encontrados!", ok: false, severity: SEVERITY.WARNING};
    case STATUSCODE.HTTP_405_METHOD_NOT_ALLOWED: return {message: "Método não permitido!", ok: false, severity: SEVERITY.WARNING};
    case STATUSCODE.HTTP_408_REQUEST_TIMEOUT: return {message: "Solicitação não atendida!", ok: false, severity: SEVERITY.WARNING};
    case STATUSCODE.HTTP_409_CONFLICT: return {message: "Conflito no servidor!", ok: false, severity: SEVERITY.WARNING};
    case STATUSCODE.HTTP_500_INTERNAL_SERVER_ERROR: return {message: "Erro do servidor!", ok: false, severity: SEVERITY.ERROR};
    default: return {message: "Erro desconhecido no servidor!", ok: false, severity: SEVERITY.ERROR};
  }
}

export const authorizationIsValid = (authorization) => {
  return (
    (authorization !== undefined) ||
    (authorization !== null) ||
    (authorization !== 'undefined') ||
    (authorization !== 'null') ||
    (authorization !== '')
  );
};

export function Ajax(url, method, json, success, error) {
  try {

    let options = {
      method: method,
      headers: {
        "Access-Control-Allow-Origin": "* ",
        "Access-Control-Allow-Headers": "Content-Type",
        'Content-Type': 'application/json; charset=utf-8',
        'Accept': 'application/json',
      }
    };
    options.headers['Authorization'] = `Bearer ${getJWT()}`;

    if ( (method === 'POST') || (method === 'PUT') ) {
      options.body = JSON.stringify(json);
    }

    fetch(
      url,
      options
    )
    .then(response => {
      return {response: response, json: response.json()};
    })
    .then(retorno => {
      if (retorno.response.ok) {
        retorno.json.then((json) => {
          if (retorno.response.ok) {
            let status = getMessageByStatusCode(retorno.response.status);

            const session_token_storage = hasJWT() ? getJWT() : '';
            if (!authorizationIsValid(session_token_storage)) {
              const authorization = retorno.response.headers.get('authorization');
              const session_token = authorization.replace("Bearer", "").trim();
              if (authorizationIsValid(authorization) && authorizationIsValid(session_token)) {
                saveJWT(session_token);
              } else {
                deleteJWT();
              }
            }

            success(json,status.message,status.severity);
          } else {
            let status = getMessageByStatusCode(retorno.response.status);
            error(json,status.message,status.severity);
          }
        });
      } else {
        let status = getMessageByStatusCode(retorno.response.status);
        error(json,status.message,status.severity);
      }
    })
    .catch(err => {
      let status = getMessageByStatusCode(STATUSCODE.HTTP_500_INTERNAL_SERVER_ERROR);
      error(err,status.message,status.severity);
    });
  } catch(err) {
    let status = getMessageByStatusCode(STATUSCODE.HTTP_500_INTERNAL_SERVER_ERROR);
    error(err,status.message,status.severity);
  }
}

export function uploadFile(path, file, success, error) {
  try {
    let url = `${BACKEND_URL}/${path}`;

    if (file == null) {
      let status = getMessageByStatusCode(STATUSCODE.HTTP_409_CONFLICT);
      error(file,'Arquivo carregado inválido!',status.severity);
    } else { // VALIDO

      var newFile = new File([file], file.name, {
        type: file.type,
      });

      let formData = new FormData();
      formData.append("file", newFile);
      fetch(url, {
        method: "POST",
        headers: {
          "Access-Control-Allow-Origin": "* ",
          "Access-Control-Allow-Headers": "Content-Type",
          'Accept': 'application/json',
          "Authorization": `Bearer ${localStorage.getItem('JWT')}`
        },
        body: formData
      }).then(response => {
        return {response: response, json: response.json()};
      })
      .then(retorno => {
        retorno.json.then((json) => {
          if (retorno.response.ok) {
            let status = getMessageByStatusCode(retorno.response.status);
            success(json,status.message,status.severity);
          } else {
            let status = getMessageByStatusCode(retorno.response.status);
            error(json,status.message,status.severity);
          }
        });
      })
      .catch(err => {
        let status = getMessageByStatusCode(STATUSCODE.HTTP_500_INTERNAL_SERVER_ERROR);
        error(err,status.message,status.severity);
      });

    } // VALIDO

  } catch(err) {
    let status = getMessageByStatusCode(STATUSCODE.HTTP_500_INTERNAL_SERVER_ERROR);
    error(err,status.message,status.severity);
  }
}

export function downloadImage(imageUrl, fileName, success, error) {
  fetch(imageUrl)
    .then(function(response) {
      if (!response.ok) {
        let status = getMessageByStatusCode(response.status);
        error({download: false},status.message,status.severity);
      }
      return response.blob(); // Converte a resposta em dados binários
    })
    .then(function(blob) {
      let status = getMessageByStatusCode(STATUSCODE.HTTP_200_OK);

      var objectURL = URL.createObjectURL(blob);
      var link = document.createElement('a');

      link.href = objectURL;
      link.download = fileName;      

      URL.revokeObjectURL(objectURL); // Libera a memória limpa

      success({download: true},status.message,status.severity);
    })
    .catch(function(err) {
      let status = getMessageByStatusCode(STATUSCODE.HTTP_500_INTERNAL_SERVER_ERROR);
      error({download: false, error: err},status.message,status.severity);
    });
}
